import $ from 'jquery';
import PaginatorComponent from '@components/paginator-component';
import CommentsService from '@ui/comments/CommentService';
import shoutboxRepository from '@ui/shoutbox/repository';
import { generateAdSlot } from 'utils/adManager'

const elements = {
    wrapper: '#shoutbox-paginator',
    template: '#paginator-template',
    triggers: '.c-paginator > a, .c-paginator ol li',
    comments: '.c-comments__wrapper',
    filters: '.c-comments-main-filters',
    header: 'header'
};

class ShoutboxPaginator
{
    constructor()
    {
        this.loading = false;
        this.scrolling = true;
    }

    change()
    {
        if (this.loading) {
            return false;
        }

        this.$loader.show();
        this.loading = true;

        const self = this;
        const commentsCollection = CommentsService.getVisibleCommentsCollection();

        const params = CommentsService.getShoutboxParams();
        params.page = params.page + 1;

        const filters = CommentsService.setShoutboxParams({ page: params.page });

        shoutboxRepository.load(filters).then(function(data) {
            commentsCollection.addComments(data.comments);
            CommentsService.getBufferCommentsCollection().addComments(data.comments);

            var height = $('.c-comments__wrapper').outerHeight();
            $('.c-comments__wrapper').css('min-height', height + 'px');

            commentsCollection.fireEvent('loaded');

            self.$loader.hide();
            self.loading = false;
        }, function() {
            self.$loader.hide();
            self.loading = false;
            self.scrolling = true;
        });
    }

    init(params)
    {
        const self = this;

        document.addEventListener('CommentsViewRendered', function() {
            const $articles = $('#c-comments .comments-list__base').find('> article');

            if ($articles.length < 8) {
                return;
            }

            generateAdSlot(
                '/52555387,21308365/rmadryt.pl_336x280_300x250_inarticle',
                [[300, 250], [336, 280]],
                $articles[6],
                $articles[7],
                'rmpl-comment-ad');


            if ($articles.length < 15) {
                return;
            }

            generateAdSlot(
                '/52555387,21308365/rmadryt.pl_300x250_infinite_1',
                [[300, 250], [336, 280]],
                $articles[13],
                $articles[14],
                'rmpl-comment-ad');

            self.scrolling = true;
        });

        this.$loader = $('<img src="/img/loader-dark_circle.svg" style="width: 50px; display: none" />');
        $(elements.wrapper).append(this.$loader);

        $(window).on('scroll touchmove mousewheel', function(e) {
            const comments = CommentsService.getVisibleCommentsCollection().get('comments');
            if (Array.isArray(comments) && comments.length === 0) {
                return;
            }
            var position = $('#shoutbox-paginator').offset();

            if (self.scrolling && ((window.innerHeight + window.scrollY - 200) >= position.top)) {
                self.scrolling = false;
                self.change();
            }
        });
    }
}

export default new ShoutboxPaginator();



// WEBPACK FOOTER //
// ./src/RMPL/CoreBundle/Resources/public/js/ui/shoutbox/paginator.js